import { get } from 'lodash'
import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import Filter from '../FilterNew'
import FullTextFilter from '../FullTextFilter'
import {
  BasePropsInfinity,
  IField,
  IFilter,
  IFilterInfinity,
  IStyleBoolProps,
  TFilterForm,
} from '../types'

interface IFilterWrapper extends IFilterInfinity, TFilterForm {
  fallBackDeleteFilter: Array<IField>
  includedFilters?: IFilter[]
  noFilters?: boolean
}
interface FilterWrapperProps
  extends BasePropsInfinity,
    IStyleBoolProps,
    IFilterWrapper {
  isMobile: boolean
  customFilterBarElement?: ReactNode
}

export const Wrapper = styled.div`
  position: absolute;
  width: calc(100% - 24px);
  height: calc(100% - 12px);
  z-index: 5;
  display: flex;
`

const Dimmer = styled.div`
  background: rgba(0, 0, 0, 0.4);
  flex: 1;
  width: calc(100% - 400px);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
`

const Container = styled.div`
  max-width: 400px;
  background: rgba(255, 255, 255, 1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
`

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 -10px;
  padding: 0 10px;
`

const FilterWrapper = (props: FilterWrapperProps): React.ReactElement => {
  const {
    filter,
    includedFilters,
    isMobile,
    ui,
    saveUi,
    noFilters,
    hideDetail = false,
    fallBackDeleteFilter,
    applyFilter,
    filterForm,
    useLocalStateFiltering = false,
    applyLocalFilter,
    setFilter,
    customFilterBarElement,
  } = props

  const detailFilterOpen = get(ui, 'isDetailOpen', false)

  const handleDimmerClick = (e: React.MouseEvent): void => {
    e.preventDefault()

    if (saveUi) {
      saveUi({ isDetailOpen: false })
    }
  }

  return (
    <React.Fragment>
      {!noFilters && (
        <FullTextFilter
          applyFilter={applyFilter as any}
          filterForm={filterForm}
          useLocalStateFiltering={useLocalStateFiltering}
          applyLocalFilter={applyLocalFilter as any}
          setFilter={setFilter as any}
          isMobile={isMobile}
          filters={filter}
          applyColor="dark"
          setDetailFilterOpen={saveUi as any}
          detailFilterOpen={detailFilterOpen}
          hideDetail={hideDetail}
          fallBackDeleteFilter={fallBackDeleteFilter}
          initialValues={{
            ...includedFilters,
          }}
          customFilterBarElement={customFilterBarElement}
        />
      )}

      {isMobile && detailFilterOpen && !noFilters && (
        <Filter
          {...props}
          filters={filter}
          isMobile={isMobile}
          applyColor="dark"
          setDetailFilterOpen={saveUi as any}
          detailFilterOpen={detailFilterOpen}
          initialValues={{
            ...includedFilters,
          }}
        />
      )}

      {!isMobile && detailFilterOpen && !noFilters && (
        <Wrapper>
          <Dimmer onClick={(e) => handleDimmerClick(e)} />

          <Container>
            <Content>
              <Filter
                {...props}
                filters={filter}
                applyColor="dark"
                isMobile={isMobile}
                initialValues={{
                  ...includedFilters,
                }}
                setDetailFilterOpen={saveUi as any}
                detailFilterOpen={detailFilterOpen}
              />
            </Content>
          </Container>
        </Wrapper>
      )}
    </React.Fragment>
  )
}

export default FilterWrapper
